import { setClientId } from "client/Misc/clientId";
import { environmentHttpClient } from "client/Api/httpClient";

const controllerRelativeUrl = "/Email/Mailboxes";

export enum MailboxType {
	Main = 0,
	Manual = 2,
}

export type AvailableMailboxModel = {
	id: number;
	emailAddress: string;
	isVisible: boolean;
	isEnabledAsSendAs: boolean;
	isEnabledAsDefaultSendAddress: boolean;
	type: MailboxType;
	sortOrder: number;
	isAutoMarkMessageAsReadOnOpen: boolean;
};

export type AvailableMailboxesListModel = {
	mailboxes: AvailableMailboxModel[];
};

export function getConfiguredMailboxes(
	signal?: AbortSignal
): Promise<AvailableMailboxesListModel> {
	return environmentHttpClient.get<AvailableMailboxesListModel>(
		controllerRelativeUrl,
		null,
		{ signal }
	);
}

export function saveMailboxes(
	model: AvailableMailboxesListSaveModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		controllerRelativeUrl,
		model,
		{ signal }
	);
}

export type MainMailboxSaveModel = {
	id: number;
	isVisible: boolean;
	isEnabledAsSendAs: boolean;
	isEnabledAsDefaultSendAddress: boolean;
	type: MailboxType.Main;
	sortOrder: number;
	isAutoMarkMessageAsReadOnOpen: boolean;
};

export type SharedMailboxSaveModel = {
	id: number;
	emailAddress: string;
	isVisible: boolean;
	isEnabledAsSendAs: boolean;
	isEnabledAsDefaultSendAddress: boolean;
	type: MailboxType.Manual;
	sortOrder: number;
	isAutoMarkMessageAsReadOnOpen: boolean;
};

export type AvailableMailboxSaveModel =
	| MainMailboxSaveModel
	| SharedMailboxSaveModel;

export type AvailableMailboxesListSaveModel = {
	mailboxes: AvailableMailboxSaveModel[];
};

export function createMailboxViewModelForNewMailbox(
	emailAddress: string,
	order: number,
	mailboxType: Exclude<MailboxType, MailboxType.Main>
): SharedMailboxSaveModel {
	const newMailbox: SharedMailboxSaveModel = setClientId({
		emailAddress: emailAddress,
		type: mailboxType,
		id: 0,
		sortOrder: order,
		isEnabledAsDefaultSendAddress: false,
		isEnabledAsSendAs: false,
		isVisible: true,
		isAutoMarkMessageAsReadOnOpen: true,
	});

	return newMailbox;
}
